export enum RiskState {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
